// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"bridge-4"},"nodeName":"g","children":[{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M4 21.0004V8.00021L3.10005 3.50027M8 21.0004V8.00021L8.9 3.50027M20 21V8L20.9 3.5M16 21.0004V8.00021L15.1 3.50002M2 3.00042L9 3.00028C9.90938 3.00033 13.8757 2.99995 15 3.00001L22 3.00042","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-bridge-4')
export default class Bridge4Icon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'bridge-4',
    }
  }
}
